const Config={
    orderCheckOutType: {
        placeOrder: 1,
        paynPlaceOrder: 2,
        both: 3
    },

    checkOutTypewithPay: false
}
module.exports = Config;